import SettingsSuggestRoundedIcon from "@mui/icons-material/SettingsSuggestRounded";

export const settings = (props) => {
  return <SettingsSuggestRoundedIcon {...props} />;
};
